import { Component, inject, Input } from '@angular/core';
import { AbstractControlOptions, UntypedFormBuilder } from '@angular/forms';
import { Geokoordinaten } from '../../../domain/model/geokoordinaten.model';
import { Geokoordinatensystem, GeokoordinatensystemItem } from '../../../domain/model/geokoordinatensystem.enum';
import { UTMGeokoordinatenValidator } from './validator/utm-geokoordinaten-validator';
import { DezimalgradGeokoordinatenValidator } from './validator/dezimalgrad-geokoordinaten-validator';
import { AbstractForm } from '../abstract-form.model';
import { FormGroupConfig } from '../form-config.model';
import { ErzeugungsanlageConfig } from '../erzeugungsanlage.config';
import { MatValidators } from '../../../common/material/components/mat-form-field-required.directive';
import { GeokoordinatenValidator } from './validator/geokoordinaten.validator';
import { Feld } from '../../../domain/model/feld.enum';

@Component({
    selector: 'redispatch-geokoordinaten-sub-form',
    templateUrl: './geokoordinaten-sub-form.component.html',
    styleUrls: [
        './geokoordinaten-sub-form.component.scss',
    ],
    standalone: false,
})
export class GeokoordinatenSubFormComponent extends AbstractForm<Geokoordinaten> {

    public readonly LYT_GAP = ErzeugungsanlageConfig.HORIZONTAL_FX_LAYOUT_GAP;

    @Input({ required: true }) readonly: boolean;

    public readonly utmGeokoordinatenValidator = UTMGeokoordinatenValidator;
    public readonly dezimalgradGeokoordinatenValidator = DezimalgradGeokoordinatenValidator;

    public readonly geokoordinatenSystem: GeokoordinatensystemItem[] = GeokoordinatensystemItem.getAll();
    public readonly Feld = Feld;

    public zoneSelection = [
        { 'id': 32, 'name': '32' },
        { 'id': 33, 'name': '33' },
    ];

    constructor() {
        super(inject(UntypedFormBuilder));
    }

    get formGroupConfig(): FormGroupConfig<Geokoordinaten> {
        return {
            geokoordinatenSystem: [
                { value: null, disabled: this.readonly },
                [
                    MatValidators.required,
                ],
            ],
            zone: [
                { value: 32, disabled: true },
                [
                    MatValidators.required,
                ],
            ],
            hochwert: [
                { value: null, disabled: true },
                [
                    MatValidators.required,
                ],
            ],
            rechtswert: [
                { value: null, disabled: true },
                [
                    MatValidators.required,
                ],
            ],
            longitude: [
                { value: null, disabled: true },
                [
                    MatValidators.required,
                ],
            ],
            latitude: [
                { value: null, disabled: true },
                [
                    MatValidators.required,
                ],
            ],
        };
    }

    get formOptions(): AbstractControlOptions | null {
        return {
            validators: GeokoordinatenValidator.validate,
        };
    }

    public sanitize(geokoordinaten: Geokoordinaten): Geokoordinaten {
        return geokoordinaten;
    }

    public isSystemDezimalGrad() {
        return this.f.geokoordinatenSystem.value === Geokoordinatensystem.DEZIMALGRAD;
    }

    public isSystemUTM() {
        return this.f.geokoordinatenSystem.value === Geokoordinatensystem.UTM;
    }

    public formChanged() {
        if (this.readonly) {
            this.f.geokoordinatenSystem.disable();
            this.f.zone.disable();
            this.f.hochwert.disable();
            this.f.rechtswert.disable();
            this.f.longitude.disable();
            this.f.latitude.disable();
        } else {
            this.f.geokoordinatenSystem.enable();
            if (this.f.geokoordinatenSystem.value === Geokoordinatensystem.UTM) {
                this.f.longitude.disable();
                this.f.latitude.disable();
                this.f.zone.enable();
                this.f.hochwert.enable();
                this.f.rechtswert.enable();
            } else if (this.f.geokoordinatenSystem.value === Geokoordinatensystem.DEZIMALGRAD) {
                this.f.longitude.enable();
                this.f.latitude.enable();
                this.f.zone.disable();
                this.f.hochwert.disable();
                this.f.rechtswert.disable();
            }
        }
    }

}
